// ############################ Require packages here ############################
import React, { lazy, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Aos from 'aos';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';


// ############################ Require files here ###############################

import ScheduleForm from '../scheduleForm';
// import TestimonialSlider from '../testimonialSlider';
import RelatedResources from '../relatedResources';
import { getOneResource } from '../../../Redux/ActionCreators/resourcesAction';
import ShareUrl from './shareUrl';
const TestimonialSlider = lazy(() => import("../testimonialSlider"));

export default function Spotlight4() {

    useEffect(() => {
        Aos.init({ duration: 2000 })
    }, [])


    const navigate = useNavigate();
    const dispatch = useDispatch();

    const setPage = (val) => {
        window.scrollTo(0, 0);
        if (val === 'contact') {
            window.scrollTo(0, 2500);
        } else if (val === 'resources') {
            navigate('/resources-hub')
        }
    }

    const downloadFactsheet = async () => {
        const res = await dispatch(getOneResource(['6a27b93888e8118a8df1838f']))
        if (res?.type === 'GET_ONE_RESOURCES') {
            navigate(`/newsroom/article/${encodeURIComponent(res.payload?.title)}`, { state: { data: res?.payload } })
        }
    }


    return (
        <div className='seq-content-page'>
            {/* section 0 PAGE HEADING */}
            <Helmet>
                <meta charSet="utf-8" />
                <title>The Mythos Moment 2: Misconceptions, Risks, Safeguards</title>
                <meta http-equiv="X-Frame-Options" content="DENY" />
                <meta name="description" content="" />
                <meta name="keywords" content="" />
                <meta property="og:title" content="" />
                <meta property="og:description" content="" />
            </Helmet>
            {/* section 1 BANNER */}
            <div className='seq-content-heading' style={{ backgroundImage: `url('/images/Spotlight4-banner.svg')` }}>
                <div className='seq-description'>
                    <h2 data-aos="fade-up">
                        <p style={{ fontSize: "36px", color: " #A2DAE0" }}>Webinar</p>
                        The Mythos Moment 2: Misconceptions, Risks, Safeguards
                    </h2>
                    <div data-aos="fade-up" className='text-center mt-3'>
                        <button onClick={() => downloadFactsheet()} class="ext-btn">Read Blog</button>
                        <button onClick={() =>
                            window.open(
                                "https://share-na2.hsforms.com/1ieVQmm8IQECWh-UQ9Oi4Pwqlq08",
                                "_blank",
                                "noopener,noreferrer"
                            )
                        } >Register Now</button>
                    </div>
                </div>
            </div>
            {/* section 2 INFO */}
            <div className='seq-content-1'>
                <div className='container pe-0'>
                    <div className='row me-0'>
                        <div className='col-md-5 col-sm-12 col-12'>
                            <h4>
                                <img src='/images/spotligh4-icon1.svg' alt='' height={60} loading="lazy" />
                                <br />   <br />
                                When AI Finds the Gaps Before You Do
                            </h4>
                        </div>
                        <div className='col-md-6 col-sm-12 offset-lg-1 col-12 seq-info-text'>
                           <p>The enterprise world is entering a defining digital era, one powered by autonomous workflows, lightning-fast data processing, and the immense capabilities of Mythos AI. Innovation has never moved faster, but this massive leap forward introduces a critical, high-stakes exposure.</p><br />
                           <p>The greatest threat facing organizations today is a matter of pure velocity: Mythos AI can scout infrastructure and expose critical vulnerabilities far faster than traditional IT and security teams can patch them. When automated exploits outpace human remediation, what used to be a manageable window of risk becomes an immediate, severe operational vulnerability.</p><br />
                           <p>To bridge this widening gap, this webinar brings you direct, actionable clarity from the frontlines of enterprise defense.</p>
                        </div>
                    </div>
                </div>
            </div>
            {/* section 3 CHALLENGES */}
            <div className="seq-content-1">
                <p style={{ textAlign: "center", color: "#2076cd" }}>
                                CHALLENGES
                            </p> <br />
                <div className="container pe-0">
                    <div className="row me-0 justify-content-center">
                        
                        <div className="col-md-3 col-sm-12 col-12 addon-bg">
                            <img src="/images/sp-Compliance.svg" alt="Compliance" height={40} />
                            <h4>Patch Velocity Gap</h4>
                            <p style={{ textAlign: "center" }}>
                                Attackers reverse-engineer a published patch in 72 hours.
                            </p>
                        </div>

                        <div className="col-md-3 col-sm-12 col-12 addon-bg">
                            <img src="/images/spotligh4-icon2.svg" alt="Risk" height={40} />
                            <h4>Brownfield Estate</h4>
                            <p style={{ textAlign: "center" }}>
                                Most BFSI IT legacy code base and vendor-locked middleware no longer exist.
                            </p>
                        </div>

                        <div className="col-md-3 col-sm-12 col-12 addon-bg">
                            <img src="/images/sp-Risk.svg" alt="Continuity" height={40} />
                            <h4>SOC Alert Overload</h4>
                            <p style={{ textAlign: "center" }}>
                                When chained exploits replace single-CVE attacks, every step looks low/medium in isolation.
                            </p>
                        </div>

                    </div>
                </div>
            </div>

            {/* section 6 */}
            <div className='seq-how-to-helps' style={{ backgroundImage: `url('/images/spotlight_para.svg')`, backgroundSize: "cover" }}>
                <div className='container'>
                    <div className='seq-help-bg'>
                        <div className='row '>
                            <div data-aos="fade-up" className=' col-md-5 col-12 seq-help-left'>
                                <p>How Sequretek Helps</p>
                                <h3>Navigate Cyber Risk with Confidence Through Sequretek’s Integrated Security Platform</h3>
                                <button onClick={() => setPage('contact')}>Get started</button>
                            </div>
                            {window.innerWidth > 767 ?
                                <div className='col-md-4  offset-md-1 seq-ind-qimg'>
                                    <img src='/images/q-icon1.svg' alt='' height={300} loading="lazy" />
                                </div> :
                                null
                            }
                        </div>
                    </div>

                </div>
            </div>
            {/* section 5 */}
            <div className='seq-content-1'>
                <div className='container pe-0'>
                    <div className='row me-0'>
                        <div className='col-md-5 col-sm-12 col-12'>
                            <img src='/images/Mythos Moment 2.svg' style={{ width: "500px !important;" }} alt='' loading="lazy" />
                        </div>
                        <div className='col-md-6 col-sm-12 offset-lg-1 col-12 seq-info-text'>
                            <h4>A candid high-impact conversation</h4><br />
                            <p>In this exclusive knowledge session, co-hosts Pankit Desai and Anand Naik, Sequretek’s CEOs & Co-Founders, will break down the mechanics of AI-driven threat acceleration. They will outline the strategic checkpoints and architectural shifts required to shrink your exposure window, helping your organization build a defense system without compromising on growth.</p>
                            <button onClick={() =>
                                window.open(
                                    "https://share-na2.hsforms.com/1ieVQmm8IQECWh-UQ9Oi4Pwqlq08",
                                    "_blank",
                                    "noopener,noreferrer"
                                )
                            } className='reserve-btn'>Register Now</button>
                        </div>
                    </div>
                </div>
            </div>

            {/* section 7 SCHEDULE DEMO FORM */}
            <div className='seq-forms'>
                <div className='container ps-4 pe-4 '>
                    <div className='col-md-12 col-sm-12 col-12  seq-info-text'>
                        <h4 className='heading_k'>How can we help improve your security posture? Let’s talk!</h4>
                    </div>
                    <div className="insurance-partseven" data-aos="fade-up">
                        <ScheduleForm
                            text={'The security of your data and infrastructure is more critical than ever. Secure your sensitive data with Sequretek’s enhanced security monitoring and threat detection and ensure that your critical information remains confidential and protected.'}
                            bg={'/images/bg-img74.svg'}
                            mobilebg={'/images/bg-img71.svg'}
                            page='banking'
                        />
                    </div>
                </div>
            </div>
            <ShareUrl
                    details={{ title: 'The Mythos Moment', url: 'https://www.sequretek.com/resources/spotlight/the-mythos-moment ' }}
            />
            {/* section 7 RELATED RESOURCES */}
            <div className='seq-resources'>
                <div className='container'>
                    <h4>Related resources</h4>
                    <div className='row ms-0 me-0'>
                        <div className='col-md-12 ps-0'>
                            <div className={window.innerWidth > 767 ? 'row ' : 'row flex-nowrap overflow-auto'}>
                                <RelatedResources
                                    page='resources'
                                    type='Blog'
                                    title='Every CISO I Know Is Asking the Wrong Question About Mythos. Here Is the Right One.'
                                />
                                <RelatedResources
                                    page='resources'
                                    type='Media Coverage'
                                    title='India cyber defence faces questions from Claude Mythos'
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {window.innerWidth > 767 ? <div className='d-flex align-items-center justify-content-center' style={{ background: '#040c30' }}><button className='seq-resource-btn' onClick={() => setPage('resources')}>Visit the resource center</button></div> : <div className='d-flex align-items-center justify-content-center' style={{ background: '#040c30' }}><button className='seq-resource-btn' onClick={() => setPage('resources')}>Resource Center</button></div>}
        </div>
    )
}